module.exports = __webpack_public_path__ + "youtube-play-e6f0c233c87ddefab049c991c61e2d69.png";


//////////////////
// WEBPACK FOOTER
// ./~/lightgallery/dist/img/youtube-play.png
// module id = 920
// module chunks = 124